import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Scan, ScannerStore, SOFTLINE_FEATURE_SCANNER } from '@softline/application';
import { Store } from '@softline/core';
import { MessageBarService, UiCoreModule } from '@softline/ui-core';
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';

@Component({
  selector: 'soft-esl-code',
  imports: [CommonModule, UiCoreModule],
  templateUrl: './esl-code.component.html',
  styleUrls: ['./esl-code.component.scss'],
})
export class EslCodeComponent implements OnInit, OnDestroy {
  private subscription?: Subscription;
  readonly #messageBarService = inject(MessageBarService);

  constructor(private store: Store) {}

  @Input() value?: string | null;

  @Output() submit = new EventEmitter<string | null | undefined>();

  ngOnInit(): void {
    this.subscription = this.store
      .observe(SOFTLINE_FEATURE_SCANNER, ScannerStore.getters.latest)
      .pipe(skip(1))
      .subscribe(async (scan) => {
        await this.validateScan(scan);
      });
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) this.subscription.unsubscribe();
    this.subscription = undefined;
  }

  onSubmit(): void {
    this.submit.emit(this.value);
    if (this.subscription && !this.subscription.closed) this.subscription.unsubscribe();
    this.subscription = undefined;
  }

  async startScan(): Promise<void> {
    await this.store.dispatch(SOFTLINE_FEATURE_SCANNER, ScannerStore.actions.scan, {
      labelType: ['code128'],
    });
  }

  async validateScan(scan: Scan | undefined): Promise<void> {
    switch (scan?.labelType) {
      case 'code128':
        this.submit.emit(scan.data);
        break;
      default:
        this.#messageBarService.error('Codetyp nicht unterstützt');
    }
  }
}
